export default defineNuxtRouteMiddleware(({ path, query, hash }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { $store } = useNuxtApp() as any;

  if (path !== '/' && path.endsWith('/')) {
    const nextPath = path.replace(/\/+$/, '') || '/';

    return navigateTo({ path: nextPath, query, hash }, { redirectCode: 301 });
  }

  const slashReplacer = (paths: string | string[]): string[] => {
    if (Array.isArray(paths)) return paths.map(path => path.replace(/\//g, '')).filter(Boolean);
    return [paths.replace(/\//g, '')];
  };

  const currentPath = slashReplacer(path)[0];
  // const pathsLogoutAllowed = slashReplacer([REGISTER_BASE_URL]);
  const pathsLoginAllowed = slashReplacer([
    PROFILE_PAGE,
    FAVOURITES_URL,
    MY_EVENTS_BASE_URL,
    MY_STARTUPS_BASE_URL
  ]);

  if ($store.getters['auth/getByField']('loggedIn')) {
    // if (pathsLogoutAllowed.includes(currentPath) && query.type !== 'event') {
    //   return navigateTo(HOME_PAGE, { replace: true, redirectCode: 301 });
    // }
  } else if (pathsLoginAllowed.includes(currentPath)) {
    return navigateTo(`/?redirect=${encodeURIComponent(currentPath)}`);
  }
});
